import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLIENT_CASE_STUDIES } from '../client-case-studies';
import { ClientCaseStudyComponent } from '../shared/client-case-study/client-case-study.component';

@Component({
  selector: 'app-la-texana',
  standalone: true,
  imports: [CommonModule, ClientCaseStudyComponent],
  templateUrl: './la-texana.component.html',
  styleUrl: './la-texana.component.scss'
})
export class LaTexanaComponent {
  readonly caseStudy = CLIENT_CASE_STUDIES.laTexana;
}
